import { FilePen } from 'lucide-react'
import { RequirePermission } from '@/features/auth/guards'
import { AdmissionDetailPage } from '@/pages/admissions/AdmissionDetailPage'
import { AdmissionSettingsPage } from '@/pages/admissions/AdmissionSettingsPage'
import { AdmissionsListPage } from '@/pages/admissions/AdmissionsListPage'
import type { AppModule } from '../moduleRegistry'

const keywords = 'admissions applications inscription online form enrol new students candidates'

export const module: AppModule = {
  id: 'admissions',
  schoolModule: 'admissions',
  routes: {
    admin: [
      {
        path: 'admissions',
        element: <RequirePermission permission="admissions.manage" />,
        children: [
          { index: true, element: <AdmissionsListPage /> },
          { path: 'settings', element: <AdmissionSettingsPage /> },
          { path: ':id', element: <AdmissionDetailPage /> },
        ],
      },
    ],
  },
  nav: {
    admin: [
      {
        // Right after Students (order 0) in "People".
        group: 'People',
        order: 5,
        item: {
          label: 'Online admissions',
          to: '/admin/admissions',
          icon: FilePen,
          permission: 'admissions.manage',
          keywords,
          children: [
            { label: 'Applications', to: '/admin/admissions', permission: 'admissions.manage', end: true },
            {
              label: 'Admission settings',
              to: '/admin/admissions/settings',
              permission: 'admissions.manage',
              keywords: 'open close places documents form',
            },
          ],
        },
      },
    ],
  },
}
